import Vue from "vue";
import { Dialog } from "vant";
import {
  showToast,
  hideToast,
  showLoading,
  hideLoading
} from "@/plugins/environment/model/toast"; // 轻提示+loading
import { showNotify } from "@/plugins/environment/model/notify";
import { getPlatform, isAPP } from "@/plugins/environment/type.js";
import { Language } from "@/language/index.js";

// msg提示内容, method回调方法
export const dialogAlert = (msg, method) => {
  let dialog = Dialog;
  dialog
    .alert({
      message: msg,
      confirmButtonText: Language.alert.confirmButtonText,
      className: "showDialogClass"
    })
    .then(() => {
      // on close
      method();
      dialog.close();
    });
};
// 弹框
export const dialogConfirm = (msg, confirm, cancel) => {
  let dialog = Dialog;
  dialog
    .confirm({
      message: msg,
      confirmButtonText: Language.alert.confirmButtonText,
      cancelButtonText: Language.alert.cancelButtonText,
      className: "showDialogClass"
    })
    .then(() => {
      confirm();
    })
    .catch(() => {
      cancel();
    });
};

//自定义弹窗
export const customAlert = (options, confirm, cancel) => {
  let dialog = Dialog;
  options.className = "showDialogClass";
  dialog
    .confirm(options)
    .then(() => {
      confirm();
    })
    .catch(() => {
      cancel();
    });
};

//自定义弹窗2
export const customAlert2 = (options, confirm, cancel) => {
  let dialog = Dialog;
  options.className = "showDialogCustomClass";
  dialog
    .confirm(options)
    .then(() => {
      confirm();
    })
    .catch(() => {
      cancel();
    });
};

//深拷贝
export function deepClone(origin) {
  var isObject = any => typeof any == "object" && any != null;
  var isArray = any => Object.prototype.toString.call(any) === "[object Array]";
  if (!isObject(origin)) return origin;
  var target = isArray(origin) ? [] : {};
  for (var prop in origin) {
    if (origin.hasOwnProperty(prop)) {
      var value = origin[prop];
      if (isObject(value)) {
        target[prop] = deepClone(value);
      } else {
        target[prop] = value;
      }
    }
  }
  return target;
}

export function customAppHeader(styleType, distance) {
  var platform = getPlatform();
  if (styleType == 1) {
    if (platform == 'ios') {
      return 'top:calc(' + distance + 'px + env(safe-area-inset-top))'
    } else {
      return 'top:' + distance + 'px';
    }
  }
  if (styleType == 2) {
    if (platform == 'ios') {
      return 'padding-top:calc(' + distance + 'px + env(safe-area-inset-top))'
    } else {
      return 'padding-top:' + distance + 'px';
    }
  }
}

export function fieldRefresh(container) {
  var isApp = isAPP();
  var platform = getPlatform();
  if (isApp && platform == "ios") {
    let el = container;
    if (typeof container === 'string') {
      el = document.querySelector(container);
    }
    if (!el && this.$el) {
      el = this.$el;
    }
    if (!el) {
      return;
    }

    const controls = el.querySelectorAll('.van-field__control');
    controls.forEach((control) => {
      const originalValue = control.value;
      control.style.opacity = '0.99';
      if (originalValue) {
        control.value = originalValue + ' ';
        setTimeout(() => {
          control.value = originalValue;
        }, 10);
      }
      setTimeout(() => {
        control.style.opacity = '1';
      }, 50);
    });
  }
}

Vue.prototype.$commonMethod = {
  dialogAlert,
  dialogConfirm,
  showToast,
  hideToast,
  showLoading,
  hideLoading,
  showNotify,
  customAlert,
  customAlert2,
  deepClone,
  customAppHeader,
  fieldRefresh
};
